export default "__VITE_ASSET__DvY1huXM__"